import { CustomScene } from '../../../types/types'

export const DiamondPendantSelectionLabel = ({ scene }: { scene: CustomScene }) => {
  // @ts-expect-error - Spiff types are not up to date
  const metadataVariantName = scene.variants[1].variantData?.thumbnail?.metadata.find((metadata) => metadata.key === 'variant_name')?.value

  return <p className="text-xs text-subdued font-calibre capitalize">{`Diamond: ${scene.variants[0].getName()} (${scene.variants[1].getName()} ${metadataVariantName})`}</p>
}
